import React, { useState, useEffect } from 'react';
import Wrapper from './styles';
import { PageHero, StripeCheckout, ShippingForm } from '../../components';
import { checkObjectProperties } from '../../utils/helpers';
import { useCartContext } from '../../context/cart_context';
import { useOrderContext } from '../../context/order_context';
import { useLanguageContext } from '../../context/language_context';
import { Link } from 'react-router-dom';

const CheckoutPage = () => {
  const { t, isArabic } = useLanguageContext();
  const {
    shipping: {
      name,
      address: { line1, postal_code, city, state, country },
    },
  } = useOrderContext();
  const { cart } = useCartContext();
  const [editingShipping, setEditingShipping] = useState(true);

  const confirmShipping = () => {
    setEditingShipping(false);
  };

  useEffect(() => {
    if (
      checkObjectProperties({ name, line1, postal_code, city, state, country })
    ) {
      return setEditingShipping(true);
    }
    setEditingShipping(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    document.title = 'Art & Bois | Checkout';
  }, []);

  return (
    <main style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
      <PageHero title={t.nav.checkout} />
      {editingShipping ? (
        <ShippingForm confirmShipping={confirmShipping} />
      ) : (
        <Wrapper className='page'>
          {cart.length < 1 ? (
            <div className='empty'>
              <h2>{t.cart.empty}</h2>
              <Link to='/products' className='btn'>
                {t.cart.fillCart}
              </Link>
            </div>
          ) : (
            <StripeCheckout />
          )}
        </Wrapper>
      )}
    </main>
  );
};

export default CheckoutPage;
